import { create } from 'zustand';

import { paymentsSDK } from '../webservices/payments-api';
import { Bank, Currency, PaymentMethod } from '../types/payment-config.type';

type PaymentState = {
    methods: PaymentMethod[];
    fetchMethods: (oauthToken: string) => Promise<void>;

    banks: Bank[];
    fetchBanks: (oauthToken: string) => Promise<void>;

    currencies: Currency[];
    fetchCurrencies: (oauthToken: string) => Promise<void>;
};

export const usePaymentStore = create<PaymentState>((set) => ({
    methods: [],
    fetchMethods: async (token) => {
        // By default, we only need active and public gateways
        const methods = await paymentsSDK.v2.gateways.getMany(
            {
                isActive: true,
                isPublic: true,
            },
            { token }
        );
        set({ methods });
    },

    banks: [],
    fetchBanks: async (token) => {
        const banks = await paymentsSDK.v2.banks.getMany({ token });
        set({ banks });
    },

    currencies: [],
    fetchCurrencies: async (token) => {
        const currencies = await paymentsSDK.v2.currencies.getMany({ token });
        set({ currencies });
    },
}));
